import theme from '@styles/theme';
const {
  rawColors: colors
} = theme;
export default {
  variants: {
    default: {
      backgroundColor: {
        default: {
          brand: colors.accent700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGrey: colors.lightGrey500
        },
        hover: {
          brand: colors.accent700,
          white: colors.neutralBlack,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack
        },
        focus: {
          brand: colors.accent700,
          white: colors.darkGrey500,
          dark: colors.darkGrey500,
          lightGrey: colors.lightGrey500
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500,
          lightGrey: colors.lightGrey500
        }
      },
      fill: {
        default: {
          brand: colors.neutralWhite,
          white: colors.darkGrey700,
          dark: colors.neutralWhite,
          lightGrey: colors.neutralWhite
        },
        hover: {
          brand: colors.neutralWhite,
          white: colors.neutralWhite,
          dark: colors.neutralWhite,
          lightGrey: colors.neutralWhite
        },
        focus: {
          brand: colors.neutralWhite,
          white: colors.neutralWhite,
          dark: colors.neutralWhite,
          lightGrey: colors.neutralWhite
        },
        disabled: {
          brand: colors.neutralWhite,
          white: colors.neutralWhite,
          dark: colors.neutralWhite,
          lightGrey: colors.neutralWhite
        }
      },
      color: {
        default: {
          brand: colors.neutralWhite,
          white: colors.darkGrey700,
          dark: colors.neutralWhite,
          lightGrey: colors.neutralWhite
        },
        hover: {
          brand: colors.neutralWhite,
          white: colors.neutralWhite,
          dark: colors.neutralWhite,
          lightGrey: colors.neutralWhite
        },
        focus: {
          brand: colors.neutralWhite,
          white: colors.neutralWhite,
          dark: colors.neutralWhite,
          lightGrey: colors.neutralWhite
        },
        disabled: {
          brand: colors.neutralWhite,
          white: colors.neutralWhite,
          dark: colors.neutralWhite,
          lightGrey: colors.neutralWhite
        }
      },
      borderColor: {
        default: {
          brand: colors.accent700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGrey: colors.lightGrey500
        },
        hover: {
          brand: colors.accent700,
          white: colors.neutralBlack,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack,
          lightGrey: colors.lightGrey500
        },
        focus: {
          brand: colors.accent700,
          white: colors.darkGrey500,
          dark: colors.darkGrey500,
          lightGrey: colors.lightGrey500
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500,
          lightGrey: colors.lightGrey500
        }
      }
    },
    outlined: {
      backgroundColor: {
        default: {
          brand: 'transparent',
          white: 'transparent',
          dark: 'transparent'
        },
        hover: {
          brand: 'transparent',
          white: colors.neutralWhite,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack
        },
        focus: {
          brand: 'transparent',
          white: colors.darkGrey700,
          dark: colors.darkGrey700
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500
        }
      },
      fill: {
        default: {
          brand: colors.neutralBlack,
          white: colors.neutralWhite,
          dark: colors.darkGrey700
        },
        hover: {
          brand: colors.neutralBlack,
          white: colors.neutralBlack,
          dark: colors.darkGrey700
        },
        focus: {
          brand: colors.darkGrey700,
          white: colors.darkGrey700,
          dark: colors.darkGrey700
        },
        disabled: {
          brand: colors.neutralWhite,
          white: colors.neutralWhite,
          dark: colors.neutralWhite
        }
      },
      color: {
        default: {
          brand: colors.neutralBlack,
          white: colors.neutralWhite,
          dark: colors.darkGrey700
        },
        hover: {
          brand: colors.darkGrey700,
          white: colors.neutralBlack,
          dark: colors.neutralWhite
        },
        focus: {
          brand: colors.neutralBlack,
          white: colors.neutralWhite,
          dark: colors.neutralWhite
        },
        disabled: {
          brand: colors.neutralWhite,
          white: colors.neutralWhite,
          dark: colors.neutralWhite
        }
      },
      borderColor: {
        default: {
          brand: colors.lightGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGrey: colors.lightGrey500
        },
        hover: {
          brand: colors.neutralBlack,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGrey: colors.lightGrey500
        },
        focus: {
          brand: colors.neutralBlack,
          white: colors.darkGrey700,
          dark: colors.darkGrey700,
          lightGrey: colors.lightGrey500
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500,
          lightGrey: colors.lightGrey500
        }
      }
    },
    iconOnly: {
      backgroundColor: {},
      color: {},
      borderColor: {},
      fill: {
        default: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700
        },
        hover: {
          brand: colors.neutralBlack,
          white: colors.neutralBlack,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack
        },
        focus: {
          brand: colors.neutralBlack,
          white: colors.neutralBlack,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500
        }
      }
    },
    link: {
      backgroundColor: {},
      color: {
        default: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700
        },
        hover: {
          brand: colors.neutralBlack,
          white: colors.neutralBlack,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack
        },
        focus: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500
        }
      },
      borderColor: {},
      fill: {
        default: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700
        },
        hover: {
          brand: colors.neutralBlack,
          white: colors.neutralBlack,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack
        },
        focus: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500
        }
      }
    },
    menu_link: {
      backgroundColor: 'transparent',
      color: {
        default: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGray: colors.lightGrey500
        },
        hover: {
          brand: colors.neutralBlack,
          white: colors.neutralBlack,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack
        },
        focus: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGray: colors.lightGrey500
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500,
          lightGray: colors.lightGrey500
        }
      },
      borderColor: {},
      fill: {
        default: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGray: colors.lightGrey500
        },
        hover: {
          brand: colors.neutralBlack,
          white: colors.neutralBlack,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack
        },
        focus: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGray: colors.lightGrey500
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500,
          lightGray: colors.lightGrey500
        }
      }
    },
    link_underline: {
      backgroundColor: {},
      color: {
        default: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGray: colors.lightGrey500
        },
        hover: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGray: colors.lightGrey500
        },
        focus: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGray: colors.lightGrey500
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500,
          lightGray: colors.lightGrey500
        }
      },
      borderColor: {},
      fill: {
        default: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGray: colors.lightGrey500
        },
        hover: {
          brand: colors.neutralBlack,
          white: colors.neutralBlack,
          dark: colors.neutralBlack,
          lightGray: colors.neutralBlack
        },
        focus: {
          brand: colors.darkGrey700,
          white: colors.neutralWhite,
          dark: colors.darkGrey700,
          lightGray: colors.lightGrey500
        },
        disabled: {
          brand: colors.lightGrey500,
          white: colors.lightGrey500,
          dark: colors.lightGrey500,
          lightGray: colors.lightGrey500
        }
      }
    }
  },
  buttonHeights: {
    small: 36,
    default: 47,
    big: 60
  },
  fontSizes: {
    micro: {
      uppercase: '12px',
      lowercase: '12px',
      none: '12px'
    },
    small: {
      uppercase: '17px',
      lowercase: '16px',
      none: '16px'
    },
    default: {
      uppercase: '24px',
      lowercase: '20px',
      none: '20px'
    },
    big: {
      uppercase: '17px',
      lowercase: '16px',
      none: '16px'
    },
    underline: {
      uppercase: '14px',
      lowercase: '14px',
      none: '14px'
    }
  },
  loading: {
    default: {
      brand: {
        color: colors.neutralWhite
      },
      white: {
        color: colors.darkGrey700
      },
      dark: {
        color: colors.neutralWhite
      }
    },
    outlined: {
      brand: {
        color: colors.neutralBlack
      },
      white: {
        color: colors.neutralWhite
      },
      dark: {
        color: colors.darkGrey700
      }
    },
    iconOnly: {
      brand: {
        color: colors.darkGrey700
      },
      white: {
        color: colors.neutralWhite
      },
      dark: {
        color: colors.darkGrey700
      }
    },
    link: {
      brand: {
        color: colors.darkGrey700
      },
      white: {
        color: colors.neutralWhite
      },
      dark: {
        color: colors.darkGrey700
      }
    }
  }
};